import { ISession } from '@wheely/web-auth-lib/legacy';

import { getCookieValue } from './cookie';

export const AUTH_COOKIE_KEY = 'wheely-driver-signup';

const getSessionFromCookie = (): ISession | undefined => {
  const savedCookieSession = getCookieValue(AUTH_COOKIE_KEY);

  if (!savedCookieSession) {
    return undefined;
  }

  return {
    accessToken: savedCookieSession.access_token || savedCookieSession.token,
    refreshToken: savedCookieSession.refresh_token,
    activated: true,
    expiresAt: isFinite(savedCookieSession.expires_at)
      ? new Date(Number(savedCookieSession.expires_at))
      : new Date(),
  };
};

export { getSessionFromCookie };
